module.exports = __webpack_public_path__ + "mz.svg?780f485924a159d4dd2963470f90ddfd";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mz.svg
// module id = 1141
// module chunks = 27